import React from "react";
import { Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./hooks/useLanguage.jsx";
import GalleryPage from "./routes/GalleryPage";
import BioPage from "./routes/BioPage";

const App = () => {
  return (
    <LanguageProvider>
      <Routes>
        <Route path="/" element={<GalleryPage />} />
        <Route path="/bio" element={<BioPage />} />
      </Routes>
    </LanguageProvider>
  );
};

export default App;
